import { render } from "./TitleOptions.vue?vue&type=template&id=54e90d96&scoped=true&ts=true"
import script from "./TitleOptions.vue?vue&type=script&lang=ts"
export * from "./TitleOptions.vue?vue&type=script&lang=ts"

import "./TitleOptions.vue?vue&type=style&index=0&id=54e90d96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e90d96"]])

export default __exports__